import React, { useRef, useEffect } from 'react';
// import { Link } from 'gatsby';
import styled from 'styled-components';
import { Flex } from '@latitude/box';
import {
  BREAKPOINT,
  COLOR,
  FONT_FAMILY,
  FONT_WEIGHT
} from '@latitude/core/utils/constants';
import { LINE_HEIGHT } from '@/utils/constants';

const basepath = '/digital-wallets/';
const data = [
  {
    id: 'apple-pay',
    label: 'Apple Pay',
    img: require('./images/apple-pay.svg').default
  },
  {
    id: 'google-pay',
    label: 'Google Pay',
    img: require('./images/google-pay.svg').default
  },
  {
    id: 'samsung-pay',
    label: 'Samsung Pay',
    img: require('./images/samsung-pay.svg').default
  }
];

const PAWContainer = styled(Flex)`
  position: relative;
  z-index: 1;
  justify-content: flex-start;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
  background-color: ${COLOR.GREY4};
  @media (min-width: ${BREAKPOINT.SM}) {
    justify-content: center;
  }
  @media (min-width: ${BREAKPOINT.MD}) {
    background-color: ${COLOR.WHITE};
  }
`;

const PAWBaseLine = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  height: 5px;
  background-color: ${COLOR.GREY4};
  width: 100%;
`;

const PAWLink = styled.a`
  position: relative;
  z-index: 2;
  padding: 24px 12px 19px;
  font-family: ${FONT_FAMILY.TITLE};
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  color: ${COLOR.BLACK} !important;
  text-align: center;
  line-height: ${LINE_HEIGHT.TIGHT.NORMAL};
  white-space: nowrap;
  border-bottom: solid 5px ${COLOR.GREY4} !important;
  &.isActive {
    border-bottom: solid 5px ${COLOR.BLUE} !important;
  }
  &:active {
    top: 0 !important;
  }
  &:hover {
    text-shadow: none !important;
  }
  @media (min-width: ${BREAKPOINT.MD}) {
    width: 150px;
    ${props =>
      props.img &&
      `font-size: 0; background: url(${props.img}) no-repeat center center;`}
  }
  @media (min-width: ${BREAKPOINT.MD}) {
    width: 190px;
  }
`;

const Links = ({ location }) => (
  <PAWContainer>
    {data.map(link => {
      const linkRef = useRef(null);
      useEffect(() => {
        if (location.pathname === `${basepath}${link.id}/`) {
          const rect = linkRef.current.getBoundingClientRect();
          if (rect.right > window.innerWidth) {
            linkRef.current.parentNode.scrollLeft =
              rect.right - window.innerWidth + 24;
          }
        }
      });
      return (
        <PAWLink
          ref={linkRef}
          key={link.id}
          img={link.img}
          href={`${basepath}${link.id}/`}
          className={
            `${basepath}${link.id}/` === location.pathname ? 'isActive' : ''
          }
          // activeClassName="isActive"
        >
          {link.label}
        </PAWLink>
      );
    })}
    <PAWBaseLine />
  </PAWContainer>
);

export default Links;
